import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessibleForwardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"accessible_forward"}/>
}
